import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Component({
    selector: 'app-notification-clear-popup',
    templateUrl: './notification-clear-popup.component.html',
    styleUrls: ['./notification-clear-popup.component.scss'],
    standalone: false
})
export class NotificationClearPopupComponent implements OnDestroy {
  public theme$: BehaviorSubject<string>;
  private unsubscriber = new ReplaySubject();
  public exportTypeForm: FormGroup;
  public selectedExportTemplate: 'standard' | 'complete' = 'standard';

  constructor(
    private themeService: ThemeService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NotificationClearPopupComponent>
  ) {
    this.theme$ = this.themeService.getTheme();

    this.exportTypeForm = this.fb.group({
      export_type: ['standard'],
    });
  }

  public confirmExport(): void {
    this.dialogRef.close({
      template: this.selectedExportTemplate,
    });
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public ngOnDestroy(): void {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }
}
